<img class="width-225" src="/assets/images/tempton-logo-blue.png">
<div class="am-flex-column am-flex-align gap-s">
  @if (title) { <span class="width-225 text-center text-450 color-title-grey">{{ title }}</span> }
  <button class="text-m blue pl-m pr-m" [routerLink]="['/']">Erneut einloggen</button>
</div>

<!-- <div id="auth-screen" class="am-flex-column gap-l" [ngClass]="userRole === 'internal' ? 'internal' : 'customer' ">

  <div class="p10 b-orange bg-white maintenance-block" *ngIf="serverIsOnMaintenance">
    <p    *ngIf="serverMaintenanceMessage" class="mb10">System Update</p>
    <span *ngIf="serverMaintenanceMessage">{{ serverMaintenanceMessage }}</span>
    <span *ngIf="!serverMaintenanceMessage"> Die Applikation befindet sich im Moment im Wartungsmodus. Bitte versuchen Sie es in wenigen Minuten erneut</span>
  </div>

  <div class="am-flex-column am-flex-center gap-m width-full bg-white auth-box-wrapper" [class.event-none]="serverMaintenanceMessage">
    <div class="mb-m logo"></div>
    <h1 class="am-flex-column am-flex-center font-icon color-title-grey">
      <span>Willkommen {{ userRole === 'customer' ? 'zum' : 'zur' }}</span>
      <span>myTempton {{  userRole === 'customer' ? 'Kundenportal' : 'SB Verwaltung' }}</span>
    </h1>
    <form class="am-flex-column am-flex-align gap-m width-full" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <input formControlName="email" type="email" placeholder="Benutzername" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" [disabled]="serverMaintenanceMessage"/>
      <div class="relative width-full">
        <input formControlName="password" [type]="showPass ? 'text' : 'password'" placeholder="Passwort" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" [disabled]="serverMaintenanceMessage"/>
        <span class="am-flex-center absolute-right-center mr-m hover-active" [ngClass]="showPass ? 'icon-admo-show-icon-16px' : 'icon-admo-hide-icon-16px'" (click)="showPass = !showPass"></span>
      </div>
      <button class="mb-xl single-wide-btn green" [disabled]="serverMaintenanceMessage">Anmelden</button>
    </form>
    <a class="underline text-m color-secondary-grey hover-active" [routerLink]="['/authentication/restore']" >Passwort vergessen</a>
    <a class="underline text-m color-secondary-grey hover-active" [routerLink]="['/authentication/activate']">Benutzerkonto aktivieren</a>
  </div>
</div> -->
